<template>
  <q-card>
    <q-linear-progress :model-value="dismissTimer" />
    <div :class="{ 'row no-wrap justify-between': dense }">
      <q-card-section>
        <slot />
      </q-card-section>
      <q-card-actions align="right">
        <q-btn color="black" flat label="OK" square @click="closeClicked = true" />
      </q-card-actions>
    </div>
  </q-card>
</template>

<script>
import { rafSequence } from 'src/services/raf';

const AUTO_CLOSE_TIME = 5000; // seconds

export default {
  name: 'ScanHelpCard',
  props: {
    dense: Boolean,
  },
  data() {
    return {
      closeClicked: false,
      dismissTimer: 0,
    };
  },
  mounted() {
    const startTime = new Date().getTime();

    rafSequence({
      onFrame: () => {
        const elapsedTime = new Date().getTime() - startTime;
        this.dismissTimer = elapsedTime / AUTO_CLOSE_TIME;
      },
      doneCondition: () => {
        if (this.dismissTimer > 1 || this.closeClicked) {
          if (this.closeClicked) {
            this.$emit('done');
          } else {
            setTimeout(() => {
              this.$emit('done');
            }, 750);
          }
          return true;
        }

        return false;
      },
    });
  },
};
</script>
